import {ListRequest} from '../view-model/internal/listrequest';
import {BaseResponse} from './internal/baseresponse';


export class DepositHistoryResult extends BaseResponse {
  data: Array<DepositHistory>;
}

export class DepositHistory {
  tran_id: string;
  remitter_name: string;
  tran_date: string;
  tran_time: string;
  tran_amt: string;
  tran_type: string;
  remitter_bank_code: string;
  remitter_account_num: string;
  tran_timestamp: Date;
  account_holder_info: string;
  used: number;
}

export class DepositHistorySearchOption {
  param: string;
  keyword: string;
  from: string;
  to: string;
  refresh: boolean;
}

export class DepositHistoryListSearch extends ListRequest {
  option = new DepositHistorySearchOption();
}



// WEBPACK FOOTER //
// ./src/app/response/deposithistoryresult.ts